import React from 'react'
import Wave from 'react-wavify'
import '../../Css/Savani.css'

const AboutSection3 = () => {
  return (
    <div className='relative overflow-hidden sm:top-[-50px] top-[-50px] z-20 '>
          <Wave fill='#F6F6F6'
            paused={false}
            style={{ display: 'flex' }}
            options={{
              height: 20,
              amplitude: 30,
              speed: 0.3,
              points: 5
            }}
            className='relative min-w-[1920px] sm:h-[30px] h-[40px] '
           />

         <div className='bg-[#F6F6F6]'>
         <div className=' pt-3 sm:pb-4 pb-5'>
            <div className='container sm:mt-11 mt-5 pb-10'>
               <h4 className='sm:text-[24px] text-[18px] font-[700] text-txt_color'>Why should you choose KALATHIYA INFOTECH?</h4>
               <p className='sm:text-[16px] text-[14px] text-[#555555] mt-5 lg:me-11 lg:pe-11 text-justify'>Choose KALATHIYA for unparalleled expertise, exceptional quality, and unwavering commitment to your success. With a proven track record of delivering innovative solutions tailored to your needs, we prioritize your satisfaction above all else. Join us and experience the difference of working with a dedicated partner who goes above and beyond to exceed your expectations.</p>

               <div>
                  <div className='flex lg:flex-nowrap flex-wrap justify-center items-stretch mt-6' >
                     <div className='lg:w-1/2 w-full 3xl:px-[45px] 2xl:px-[40px] lg:px-[30px] mt-5' data-aos="fade-up" data-aos-duration="1000">
                        <div className='ds_about_gradiant rounded-[30px] p-3 h-full'>
                            <div className='bg-white rounded-[30px] sm:mx-5 py-1'> 
                              <h5 className='text-txt_color sm:text-[18px] text-[16px]  text-center font-[700] px-2'>Highly Experienced and Productive Professionals</h5>
                            </div>
                            <p className='sm:text-[16px] text-[14px] text-white text-center mt-4 2xl:px-10 sm:px-5 px-2'>Our member of workforce are expert in the IT industry and have various experience in different languages. Morever we have professional and exclusive resources to provide competitive solutions.</p>
                        </div>
                     </div>
                     <div className='lg:w-1/2 w-full 3xl:px-[45px] 2xl:px-[40px] lg:px-[30px] mt-5' data-aos="fade-up" data-aos-duration="1000">
                        <div className='ds_about_gradiant rounded-[30px] p-3 h-full'>
                            <div className='bg-white rounded-[30px] sm:mx-5 py-1'> 
                              <h5 className='text-txt_color sm:text-[18px] text-[16px] text-center font-[700] px-2'>The Proper Hierarchy and Escalation Path</h5>
                            </div>
                            <p className='sm:text-[16px] text-[14px] text-white text-center mt-4 2xl:px-10 sm:px-5 px-2'>We believe in clear hierarchy and escalation path ensures streamlined communication a nd effective decision-making within the team. By defining roles and responsibilities, addressing issues promptly, and escalating concerns as needed.</p>
                        </div>
                     </div>
                  </div>

                  <div className='flex lg:flex-nowrap flex-wrap justify-center items-stretch lg:mt-5' >
                     <div className='2xl:w-2/5 lg:w-1/2 w-full 3xl:px-[45px] 2xl:px-[40px] lg:px-[30px]  lg:mt-3 mt-5' data-aos="fade-up" data-aos-duration="1000">
                        <div className='ds_about_gradiant rounded-[30px] p-3 h-full'>
                            <div className='bg-white rounded-[30px] sm:mx-5 py-1'> 
                              <h5 className='text-txt_color sm:text-[18px] text-[16px] text-center font-[700] px-2'>Expertise in multiple domains</h5>
                            </div>
                            <p className='sm:text-[16px] text-[14px] text-white text-center mt-4 2xl:px-10 sm:px-5 px-2'>We have boasts expertise across diverse domains, ranging from software development and data analytics to cybersecurity and cloud computing. With a versatile team of professionals, we offer comprehensive solutions tailored to meet the unique needs of each project.</p>
                        </div>
                     </div>
                     <div className='2xl:w-2/5 lg:w-1/2 w-full  3xl:px-[45px] 2xl:px-[40px] lg:px-[30px] lg:mt-3 mt-5' data-aos="fade-up" data-aos-duration="1000">
                        <div className='ds_about_gradiant rounded-[30px] p-3 h-full'>
                            <div className='bg-white rounded-[30px] sm:mx-5 py-1'> 
                              <h5 className='text-txt_color sm:text-[18px] text-[16px] text-center font-[700] px-2'>Reporting Structure</h5>
                            </div>
                            <p className='sm:text-[16px] text-[14px] text-white text-center mt-4 2xl:px-10 sm:px-5 px-2'>We use many project management related tools to manage project work, time, planning, designing and execution. Main point of using this tools is to provide daily , weekly and monthly reports.</p>
                        </div>
                     </div>
                  </div>

                  <div className='flex lg:flex-nowrap flex-wrap justify-center items-stretch lg:mt-5' >
                     <div className='2xl:w-1/3 lg:w-1/2 w-full 3xl:px-[45px] 2xl:px-[40px] lg:px-[30px] lg:mt-3 mt-5' data-aos="fade-up" data-aos-duration="1000">
                        <div className='ds_about_gradiant rounded-[30px] p-3 h-full'>
                            <div className='bg-white rounded-[30px] sm:mx-5 py-1'> 
                              <h5 className='text-txt_color sm:text-[18px] text-[16px] text-center font-[700] px-2'>Intellectual Property Rights Protection</h5>
                            </div>
                            <p className='sm:text-[16px] text-[14px] text-white text-center mt-4 lg:px-0 sm:px-5 px-2'>Ensuring the safeguarding of intellectual property rights, we prioritize confidentiality and employ robust security measures, fortifying trust and protecting innovation.</p>
                        </div>
                     </div>
                     <div className='2xl:w-1/3 lg:w-1/2 w-full 3xl:px-[45px] 2xl:px-[40px] lg:px-[30px] lg:mt-3 mt-5' data-aos="fade-up" data-aos-duration="1000">
                        <div className='ds_about_gradiant rounded-[30px] p-3 h-full'>
                            <div className='bg-white rounded-[30px] sm:mx-5 py-1 '> 
                              <h5 className='text-txt_color sm:text-[18px] text-[16px] text-center font-[700] px-2'>24x7 Support</h5>
                            </div>
                            <p className='sm:text-[16px] text-[14px] text-white text-center mt-4 lg:px-0 sm:px-5 px-2'>We don't disappoint our client any time. Once you shared your problem we would not stop till is is clear and client is satisfied. We provide 24*7 support for everyone</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>  
         </div>
         </div>
    </div>
  )
}

export default AboutSection3
